<template>
  <section class="chi-siamo">
    <div class="overlay">
      <h1 class="titolo">
        CHI SIAMO
        <span class="underline"></span>
      </h1>

      <p>
        Tecnoservice è un'azienda fondata nel 1991, specializzata in elettronica e automazione industriale. Dal 1996 si dedica alla progettazione e produzione di impianti elletronici per mezzi da lavoro (come autogrù, escavatori e piattaforme aeree), sviluppando il sistema TCAN per garantire sicurezza, affidabilità e flessibilità.
      </p>

      <p>
        Offre un servizio completo che va dalla progettazione del prototipo al prodotto finito, con soluzioni personalizzate e tempi certi grazie a laboratori interni e collaborazioni esterne. Fornisce anche assistenza post-vendita con supporto tecnico diretto e un archivio digitale riservato per ogni cliente.
      </p>
    </div>
  </section>
</template>


<script>
    export default {
      name: 'ChiSiamo',
      props: {
        msg: String
      }
    }
</script>

<style lang="scss" scoped>

 .chi-siamo {
  //Immagine di background
   background-image: url('@/assets/chisiamo_bg');
   background-size: cover; //fa in modo che l'immagine copra l'intero contenitore

   position: relative;
   display: flex;
   justify-content: flex-end;
   min-height: 80vh;
}
//Overlay bianco semi-trasparente
.overlay {
  //Questo codice oltre a dire la dimensione dell'overlay, detta anche come racchiudere il testo al suo interno
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: start;
  padding: 4rem;
  width: 50%;
  background-color: rgba(255, 255, 255, 0.70);
}

.titolo {
  font-size: 2.3rem;
  position: relative;
  margin-bottom: 5vh;
  &::after {
    //Tutto questo codice serve a creare la barra verde al di sotto della scritta "Chi siamo"
    content: "";
    display: block;
    background-color: $tcan_green;
    width: 10vw;
    height: 5px;
  }
}

//Testo
p {
  font-size: 1.1rem;
  line-height: 1.6;

  //Questo codice serve a dire che va applicato il suo contenuto solo al primo tag <p> che incontra
  &:first-of-type {
    margin-bottom: 10vh;
  }

  //Questo codice serve per far arrivare il testo fino a fine riga
  text-align: justify;
  hyphens: auto;
  word-break: break-word
}

// Per renderlo un minimo mobile-freindly
@media (max-width: 768px) {
  .overlay {
    width: 100%;
    padding: 2rem;
  }

  .titolo::after {
    width: 20vw;
  }
}

</style>
